import * as i0 from '@angular/core';
import { input, Component, ChangeDetectionStrategy, computed, output } from '@angular/core';
import { NgxIcon } from '@digipay/ngx-icon';
import { NgClass } from '@angular/common';
import { NgxButtonComponent } from '@digipay/ngx-button';
const _c0 = a0 => ({
  "size-24": a0
});
const _c1 = a0 => ({
  "shadow-box": a0
});
function ListMessageComponent_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.backgroundClass());
  }
}
function ListMessageComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 3);
    i0.ɵɵelement(2, "lib-blinker");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ListMessageComponent_Conditional_1_Conditional_3_Template, 1, 1, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.backgroundClass());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(3, !ctx_r0.showLine() ? 3 : -1);
  }
}
const _c2 = a0 => ["messages-container", a0];
const _c3 = () => ({
  name: "arrow-2-left"
});
function NgxCalloutComponent_Case_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.titleIcon().name)("iconSize", ctx_r0.titleIcon().size)("type", ctx_r0.titleIcon().type)("classes", ctx_r0.titleIcon().classes);
  }
}
function NgxCalloutComponent_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, NgxCalloutComponent_Case_1_Conditional_1_Template, 1, 4, "ngx-icon", 2);
    i0.ɵɵelementStart(2, "span", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r0.showTitleIcon() ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.title());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.message());
  }
}
function NgxCalloutComponent_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "lib-blinker", 6);
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("showShadow", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.message());
  }
}
function NgxCalloutComponent_Case_3_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lib-blinker", 6);
  }
  if (rf & 2) {
    i0.ɵɵproperty("showShadow", true);
  }
}
function NgxCalloutComponent_Case_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, NgxCalloutComponent_Case_3_Conditional_0_Conditional_1_Template, 1, 1, "lib-blinker", 6);
    i0.ɵɵelementStart(2, "span", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r0.showTitleBlink() ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.title());
  }
}
function NgxCalloutComponent_Case_3_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lib-list-message", 11);
  }
  if (rf & 2) {
    let tmp_12_0;
    let tmp_13_0;
    const messageObject_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("message", messageObject_r2.text)("showDot", (tmp_12_0 = messageObject_r2.showDot) !== null && tmp_12_0 !== undefined ? tmp_12_0 : true)("showLine", (tmp_13_0 = messageObject_r2.showLine) !== null && tmp_13_0 !== undefined ? tmp_13_0 : true)("backgroundClass", ctx_r0.backgroundClass());
  }
}
function NgxCalloutComponent_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxCalloutComponent_Case_3_Conditional_0_Template, 4, 2, "div", 8);
    i0.ɵɵelementStart(1, "div", 9)(2, "div", 10);
    i0.ɵɵrepeaterCreate(3, NgxCalloutComponent_Case_3_For_4_Template, 1, 4, "lib-list-message", 11, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(0, ctx_r0.showTitleBlink() || ctx_r0.title() ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2, ctx_r0.messagesDashed() ? "dashed" : ""));
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r0.messages());
  }
}
function NgxCalloutComponent_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1, " Please Select Correct Mode ");
    i0.ɵɵelementEnd();
  }
}
function NgxCalloutComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 15)(2, "ngx-button", 16);
    i0.ɵɵlistener("clickHandler", function NgxCalloutComponent_Conditional_5_Template_ngx_button_clickHandler_2_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onCtaClick($event));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵstyleMap("link");
    i0.ɵɵproperty("size", "small")("leftIcon", i0.ɵɵpureFunction0(5, _c3));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.cta(), " ");
  }
}
let BlinkerComponent = /*#__PURE__*/(() => {
  class BlinkerComponent {
    constructor() {
      this.showShadow = input(false);
    }
    static {
      this.ɵfac = function BlinkerComponent_Factory(t) {
        return new (t || BlinkerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BlinkerComponent,
        selectors: [["lib-blinker"]],
        inputs: {
          showShadow: [i0.ɵɵInputFlags.SignalBased, "showShadow"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 6,
        consts: [[1, "d-flex", "justify-content-center", "align-items-center", 3, "ngClass"], [1, "surface-brand", "size-8", "radius-rounded", 3, "ngClass"]],
        template: function BlinkerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, ctx.showShadow()));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1, ctx.showShadow()));
          }
        },
        dependencies: [NgClass],
        styles: [".shadow-box[_ngcontent-%COMP%]{animation-name:_ngcontent-%COMP%_blinker;animation-duration:1s;animation-delay:.1s;animation-iteration-count:infinite;animation-timing-function:ease-in-out}.size-8[_ngcontent-%COMP%]{width:8px;height:8px}.size-24[_ngcontent-%COMP%]{width:24px;height:24px}@keyframes _ngcontent-%COMP%_blinker{0%{-webkit-box-shadow:0 0 0 0 var(--surface-brand-tint);box-shadow:0 0 0 0 var(--surface-brand-tint)}to{-webkit-box-shadow:0 0 0 6px var(--surface-brand-tint);box-shadow:0 0 0 6px var(--surface-brand-tint)}}"],
        changeDetection: 0
      });
    }
  }
  return BlinkerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NgxCalloutTitleIconDefault = {
  name: 'info-circle',
  size: '20px',
  type: 'bold',
  classes: 'text-onback-brand'
};
let ListMessageComponent = /*#__PURE__*/(() => {
  class ListMessageComponent {
    constructor() {
      this.message = input.required();
      this.showDot = input.required();
      this.showLine = input.required();
      this.backgroundClass = input.required();
    }
    static {
      this.ɵfac = function ListMessageComponent_Factory(t) {
        return new (t || ListMessageComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListMessageComponent,
        selectors: [["lib-list-message"]],
        inputs: {
          message: [i0.ɵɵInputFlags.SignalBased, "message"],
          showDot: [i0.ɵɵInputFlags.SignalBased, "showDot"],
          showLine: [i0.ɵɵInputFlags.SignalBased, "showLine"],
          backgroundClass: [i0.ɵɵInputFlags.SignalBased, "backgroundClass"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 3,
        consts: [[1, "d-flex"], [1, "prefix"], [1, "pb-small", "c-2", "text-onback-medium", 3, "ngClass"], [1, "dot-container", 3, "ngClass"], [1, "hide-line", 3, "ngClass"]],
        template: function ListMessageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ListMessageComponent_Conditional_1_Template, 4, 2, "div", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.showDot() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.backgroundClass());
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.message(), " ");
          }
        },
        dependencies: [BlinkerComponent, NgClass],
        styles: [".prefix[_ngcontent-%COMP%]{position:relative}.prefix[_ngcontent-%COMP%]   .dot-container[_ngcontent-%COMP%]{width:20px;height:18px;display:flex;align-items:center}.prefix[_ngcontent-%COMP%]   .hide-line[_ngcontent-%COMP%]{height:calc(100% - 18px)}"],
        changeDetection: 0
      });
    }
  }
  return ListMessageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxCalloutComponent = /*#__PURE__*/(() => {
  class NgxCalloutComponent {
    constructor() {
      // Inputs
      /**
       * Basic property defines Callout Structure.
       * Default is `single-with-title`
       */
      this.mode = input('single-with-title');
      /**
       * Used in `single-with-title` and `multiple` modes
       */
      this.title = input('توجه داشته باشید');
      /**
       * Used in `single-with-title`
       */
      this.showTitleIcon = input(true);
      /**
       * Used in `single-with-title`. Its type is `NgxCalloutTitleIcon`, and use ngx-icon package.
       */
      this.titleIcon = input(NgxCalloutTitleIconDefault);
      /**
       * Used in `single-with-title` and `single-without-title` modes.
       */
      this.message = input('');
      /**
       * Used only in `multiple` mode. For example value `false` is used when the messages don't relate to each other
       */
      this.messagesDashed = input(true);
      /**
       * Used only in `multiple` mode. It has two type: `string[]` and `NgxCalloutMessage[]`.
       * The second one is good when we want to have custom show/hide of dot and line
       */
      this.messages = input([], {
        transform: inputMessages => {
          if (inputMessages[0] && typeof inputMessages[0] === 'string') {
            return this.makeMessagesWithConfig(inputMessages);
          } else {
            return this.HandlePossibleUiProblem(inputMessages);
          }
        }
      });
      this.cta = input('');
      /**
       * Used only in `multiple` mode.
       */
      this.showTitleBlink = input(true);
      /**
       * Used in all modes to change background
       */
      this.backgroundMode = input('default');
      // Signals
      this.backgroundClass = computed(() => this.backgroundMode() === 'default' ? 'surface-back' : 'surface-elevated');
      // Events
      this.ctaClick = output();
    }
    onCtaClick($event) {
      this.ctaClick.emit($event);
    }
    makeMessagesWithConfig(inputMessages) {
      const messages = inputMessages.map(message => ({
        text: message
      }));
      const messagesLen = messages.length;
      messages[messagesLen - 1].showLine = false;
      return messages;
    }
    HandlePossibleUiProblem(inputMessages) {
      const messages = [...inputMessages];
      const messagesLen = messages.length;
      messages[messagesLen - 1].showLine = false;
      for (let i = 1; i < messagesLen; i++) {
        if (messages[i].showDot === false && messages[i - 1].showLine === true) {
          messages[i - 1].showLine = false;
        }
      }
      return messages;
    }
    static {
      this.ɵfac = function NgxCalloutComponent_Factory(t) {
        return new (t || NgxCalloutComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxCalloutComponent,
        selectors: [["ngx-callout"]],
        inputs: {
          mode: [i0.ɵɵInputFlags.SignalBased, "mode"],
          title: [i0.ɵɵInputFlags.SignalBased, "title"],
          showTitleIcon: [i0.ɵɵInputFlags.SignalBased, "showTitleIcon"],
          titleIcon: [i0.ɵɵInputFlags.SignalBased, "titleIcon"],
          message: [i0.ɵɵInputFlags.SignalBased, "message"],
          messagesDashed: [i0.ɵɵInputFlags.SignalBased, "messagesDashed"],
          messages: [i0.ɵɵInputFlags.SignalBased, "messages"],
          cta: [i0.ɵɵInputFlags.SignalBased, "cta"],
          showTitleBlink: [i0.ɵɵInputFlags.SignalBased, "showTitleBlink"],
          backgroundMode: [i0.ɵɵInputFlags.SignalBased, "backgroundMode"]
        },
        outputs: {
          ctaClick: "ctaClick"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 6,
        vars: 5,
        consts: [[3, "dir"], [1, "d-flex", "align-items-start", "gap-tiny", "mb-low"], [3, "name", "iconSize", "type", "classes"], [1, "c-2", "text-onback-medium"], [1, "c-2", "text-onback-high", "text-align-start", "pre-line"], [1, "d-flex", "gap-low"], [3, "showShadow"], [1, "c-2", "tex-onback-medium"], [1, "d-flex", "mb-small"], [3, "ngClass"], [1, "messages"], [3, "message", "showDot", "showLine", "backgroundClass"], [1, "st-8", "text-onback-high", "mr-low"], [1, "text-onback-error", "text-align-center"], [1, "border-300", "border-color-light", "mb-tiny", "mt-medium"], [1, "d-flex", "justify-content-end", "mb-minus-small"], [3, "clickHandler", "size", "leftIcon"]],
        template: function NgxCalloutComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, NgxCalloutComponent_Case_1_Template, 6, 3)(2, NgxCalloutComponent_Case_2_Template, 4, 2)(3, NgxCalloutComponent_Case_3_Template, 5, 4)(4, NgxCalloutComponent_Case_4_Template, 2, 0)(5, NgxCalloutComponent_Conditional_5_Template, 4, 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_2_0;
            i0.ɵɵclassMap("p-medium radius-plus " + ctx.backgroundClass());
            i0.ɵɵproperty("dir", "rtl");
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, (tmp_2_0 = ctx.mode()) === "single-with-title" ? 1 : tmp_2_0 === "single-without-title" ? 2 : tmp_2_0 === "multiple" ? 3 : 4);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(5, ctx.cta() ? 5 : -1);
          }
        },
        dependencies: [NgxIcon, BlinkerComponent, NgxButtonComponent, NgClass, ListMessageComponent],
        styles: [".pre-line[_ngcontent-%COMP%]{white-space:pre-line}.messages-container[_ngcontent-%COMP%]{transform:translate(-11px);border-right:2px dashed transparent}.messages-container.dashed[_ngcontent-%COMP%]{border-right:2px dashed lightgray}.messages-container[_ngcontent-%COMP%]   .messages[_ngcontent-%COMP%]{transform:translate(5px)}.remove-border-top[_ngcontent-%COMP%]:before{content:\"\";position:absolute;width:8px;height:8px;box-sizing:border-box;background-color:var(--surface-back);top:0;right:8px}.remove-border-bottom[_ngcontent-%COMP%]:after{content:\"\";position:absolute;width:8px;height:calc(100% - 16px);box-sizing:border-box;background-color:var(--surface-back);bottom:0;right:8px}.mb-minus-small[_ngcontent-%COMP%]{margin-bottom:-8px}.position-relative[_ngcontent-%COMP%]{position:relative}"],
        changeDetection: 0
      });
    }
  }
  return NgxCalloutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-callout
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxCalloutComponent };
